<template>

  <div class="playbook-card box" style="margin-bottom: 2rem;">
    <!-- Playbook header -->
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <h2 v-if="!editingName" class="title is-4" style="text-transform: uppercase; margin-bottom: 0;">
            {{ playbook.name }}
          </h2>
          <div v-else class="field has-addons">
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="nameForm"
                placeholder="Playbook name"
              />
            </div>
            <div class="control">
              <button class="button is-success" @click="handleSaveName">Save</button>
            </div>
            <div class="control">
              <button class="button" @click="editingName = false">Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button
            class="button is-small is-outlined"
            @click="startEditName"
          >
            <span class="icon"><i class="fas fa-pencil-alt"></i></span>
          </button>
        </div>
        <div class="level-item">
          <button
            class="button is-small is-danger is-outlined"
            @click="handleDeletePlaybook"
          >
            <span class="icon"><i class="fas fa-trash"></i></span>
          </button>
        </div>
      </div>
    </div>

    <hr style="margin: 0.75rem 0;">

    <!-- Bucket management -->
    <div class="level" style="margin-bottom: 0.5rem;">
      <div class="level-left">
        <div class="level-item">
          <strong>Buckets</strong>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button
            class="button is-small is-link is-outlined"
            @click="showBucketForm = !showBucketForm"
          >
            <span class="icon"><i class="fas fa-plus"></i></span>
            <span>Bucket</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Create bucket form -->
    <bucket-form
      v-if="showBucketForm"
      :errors="errors"
      :saving="loading"
      @save="handleCreateBucket"
      @cancel="showBucketForm = false"
    />

    <!-- Edit bucket form -->
    <bucket-form
      v-if="editingBucket"
      :bucket="editingBucket"
      :errors="errors"
      :saving="loading"
      @save="handleUpdateBucket"
      @cancel="editingBucket = null"
    />

    <!-- Bucket tabs -->
    <bucket-tabs
      v-if="playbook.buckets && playbook.buckets.length"
      :buckets="playbook.buckets"
      :active-bucket-id="activeBucketId"
      @select="activeBucketId = $event"
      @edit="startEditBucket"
      @delete="handleDeleteBucket"
    />

    <!-- Plays for active bucket -->
    <div v-if="activeBucket" class="panel" style="margin-top: 1rem;">
      <div class="panel-block" style="display: block;">
        <play-list
          :plays="activeBucket.plays || []"
          :playbook-id="playbook.id"
          :bucket-id="activeBucket.id"
          :errors="errors"
          :saving="loading"
          @create-play="$emit('create-play', $event)"
          @update-play="$emit('update-play', $event)"
          @delete-play="$emit('delete-play', $event)"
        />
      </div>
    </div>

    <div v-else-if="!playbook.buckets || !playbook.buckets.length" class="notification is-light" style="margin-top: 1rem;">
      No buckets yet. Create one to get started.
    </div>
  </div>

</template>
<script>

  import BucketTabs from './BucketTabs.vue';
  import BucketForm from './BucketForm.vue';
  import PlayList from './PlayList.vue';

  export default {

    components: {
      BucketTabs,
      BucketForm,
      PlayList,
    },

    props: {
      playbook: {
        type: Object,
        required: true,
      },
      errors: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    data () {
      let buckets = this.playbook.buckets || [];
      return {
        activeBucketId: buckets.length ? buckets[0].id : null,
        editingName: false,
        nameForm: '',
        showBucketForm: false,
        editingBucket: null,
      };
    },

    computed: {

      activeBucket () {
        if (!this.activeBucketId || !this.playbook.buckets) {
          return null;
        }
        return this.playbook.buckets.find(b => b.id === this.activeBucketId) || null;
      },

    },

    watch: {

      'playbook.buckets' (buckets) {
        if (!buckets || !buckets.length) {
          this.activeBucketId = null;
          return;
        }
        let exists = buckets.find(b => b.id === this.activeBucketId);
        if (!exists) {
          this.activeBucketId = buckets[0].id;
        }
      },

    },

    methods: {

      startEditName () {
        this.nameForm = this.playbook.name;
        this.editingName = true;
      },

      handleSaveName () {
        this.$emit('update-playbook', {
          id: this.playbook.id,
          name: this.nameForm,
        });
        this.editingName = false;
      },

      handleDeletePlaybook () {
        if (!confirm(`Delete playbook "${this.playbook.name}"? All buckets and plays within it will also be deleted.`)) {
          return;
        }
        this.$emit('delete-playbook', {id: this.playbook.id});
      },

      handleCreateBucket (form) {
        this.$emit('create-bucket', {
          playbookId: this.playbook.id,
          ...form,
        });
        this.showBucketForm = false;
      },

      startEditBucket (bucket) {
        this.editingBucket = bucket;
      },

      handleUpdateBucket (form) {
        this.$emit('update-bucket', {
          playbookId: this.playbook.id,
          bucketId: this.editingBucket.id,
          ...form,
        });
        this.editingBucket = null;
      },

      handleDeleteBucket (bucket) {
        this.$emit('delete-bucket', {
          playbookId: this.playbook.id,
          bucketId: bucket.id,
        });
        if (this.activeBucketId === bucket.id) {
          this.activeBucketId = null;
        }
      },

    },
  };

</script>
